import { FC } from 'react';
import styled from 'styled-components';
import Button from '../Button';

const NoMeasurements = styled.div(({ theme }) => {
  const { color, type } = theme;

  return `
    margin-top: 2rem;
    font-size: ${type.size.large};
    color: ${color.grayscale[0]};
    text-align: center;
    grid-column: 1 / -1;
    display: block;
  `;
});

const NoMeasurementsText = styled.h3`
  margin-bottom: 2rem;
`;

export interface INoSessions {
  callback: (session: number) => void;
}

const NoSessions: FC<INoSessions> = ({ callback }) => {
  return (
    <NoMeasurements>
      <NoMeasurementsText>No records of your sessions found</NoMeasurementsText>
      <Button onClick={() => callback(0)}>View All Sessions</Button>
    </NoMeasurements>
  );
};

export default NoSessions;
